import { render, staticRenderFns } from "./Col1.vue?vue&type=template&id=6e4f2cfc&scoped=true"
import script from "./Col1.vue?vue&type=script&lang=js"
export * from "./Col1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4f2cfc",
  null
  
)

export default component.exports